function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "grp82vqi3a",
  d: "M16.25 2.25l1.103.588c.365.195.504.65.309 1.015-.179.335-.576.48-.922.35l-.093-.041-.771-.412h-.89l.54.722c.13.13.203.299.216.473v.122c-.013.174-.086.343-.215.473l-.876 1.172C16.76 6.835 18 7.292 18 9l.667 10c0 .733-.159.725-.667 1.183l-.773.502.008.017.038.095c.111.352-.052.741-.395.903-.374.177-.822.017-.999-.357l-.24-.51H8.36l-.325.69c-.177.375-.624.535-.998.358-.344-.162-.507-.551-.395-.904l.037-.094.092-.198L6 20.183c-.472-.425-.642-.448-.664-1.037L5.333 19 6 9c0-1.705 1.236-2.164 3.339-2.288l-.883-1.177c-.128-.132-.2-.303-.21-.479v-.1c.01-.176.082-.347.21-.479L9 3.75h-.814l-.854.422c-.34.169-.747.055-.953-.252l-.051-.088c-.169-.34-.055-.747.252-.953l.088-.051 1.17-.578h8.412zm-.5 14.417c-.692 0-1.25.558-1.25 1.25 0 .691.558 1.25 1.25 1.25l-.055-.004c.14-.063.29-.08.431-.056.507-.157.874-.63.874-1.19 0-.692-.558-1.25-1.25-1.25zm-7.5 0c-.692 0-1.25.558-1.25 1.25 0 .56.367 1.033.874 1.192.141-.026.29-.01.431.054.666-.026 1.195-.573 1.195-1.246 0-.692-.558-1.25-1.25-1.25zm7.53-7.652H8.264c-.516 0-.948.393-.996.908l-.473 5.092H17.2l-.424-5.083c-.043-.518-.476-.917-.996-.917zM13.112 3.75h-2.237l-.94 1.255L11.1 6.563c.026.033.047.068.066.104h1.658l.004-.01.06-.094 1.164-1.558-.94-1.255z"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-253.000000, -633.000000) translate(34.000000, 580.000000) translate(10.289855, 50.000000) translate(206.231884, 0.000000) translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "fz9l8oas5b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#grp82vqi3a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#263238",
  fillRule: "nonzero",
  xlinkHref: "#grp82vqi3a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#fz9l8oas5b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24.24V24.24H0z"
}))));
function SvgTram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram);
export default __webpack_public_path__ + "static/media/tram.ab476a53af38546ef7ad7157ea99f11c.svg";
export { ForwardRef as ReactComponent };